
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {  ProductSubCategoryMstApi } from '../../api/master/productsubcategory-mst.api';
import { ProductSubCategoryMst, ProductSubCategoryMstData } from '../../interface/master/procductsubcategory-mst';

@Injectable()
export class  ProductSubCategoryMstService extends  ProductSubCategoryMstData {

  constructor(private api:  ProductSubCategoryMstApi) {
    super();
  }
  list(url: string): Observable< ProductSubCategoryMst[]> {
    return this.api.list(url);
  }
  getById(url:string): Observable< ProductSubCategoryMst>{
      return this.api.getById(url);
  }
  create(url: string, data: ProductSubCategoryMst): Observable< ProductSubCategoryMst> {
    return this.api.add(url,data);
  }
  update(url: string, data: ProductSubCategoryMst): Observable< ProductSubCategoryMst> {
    return this.api.update(url,data);
  }
  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
